import axios from "axios";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Col, Row, Input, Label } from "reactstrap";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import { ReviewedLeaveApplication_API } from "./ReviewedLeaveApplication_API";
import { Config, Routes } from "../../../configurations/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import FormStatus from "../../../components/FormStatus";

function ReviewedLeaveApplicationDetail() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const [formStatus, setFormStatus] = useState(null);
	const [attachedFileName, setAttachedFileName] = useState("");
	const [reviewLeaveDetailData, setReviewLeaveDetailData] = useState({});

	useEffect(() => {
		var tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${ReviewedLeaveApplication_API.GetReviewedLeaveById}/${id}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setFormStatus(data.leaveApplicationStatus);
					setReviewLeaveDetailData(data);
					setAttachedFileName(data.attachmentFile);
				}
			});
	}, []);

	const getImageByStatus = (status) => {
		switch (status.toLowerCase()) {
			case "approved":
				return (
					<img
						title="Approved"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/approved.jpg"
					/>
				);
			case "rejected":
				return (
					<img
						title="Rejected"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/rejected.png"
					/>
				);
			case "invalid":
				return (
					<img
						title="Invalid"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/invalid.png"
					/>
				);
			default:
				return (
					<img
						title="Pending"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/pending.png"
					/>
				);
		}
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<FormStatus
								id={id}
								title="Review Leave Application Detail"
								formStatus={formStatus}
								className="create-request d-flex align-items-center"
								onClick={() =>
									history.push(Routes.SpReviewedLeave)
								}
								navigateBack={true}
							/>

							<div className="formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>
										View Leave Application
									</Label>
								</div>

								<Col>
									<Row className="py-2 px-2">
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Name</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.employeeName
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Application ID</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveApplicationId
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Type</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveType
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Applied Date</div>
											</div>
										</Col>
										<Col md={3} lg={3}>
											<p className="formValueContainer">
												{reviewLeaveDetailData.leaveAppliedDate &&
													moment(
														reviewLeaveDetailData.leaveAppliedDate
													).format("DD/MM/YYYY")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Start Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{reviewLeaveDetailData.leaveStartDate &&
													moment(
														reviewLeaveDetailData.leaveStartDate
													).format("DD/MM/YYYY")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>End Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{reviewLeaveDetailData.leaveEndDate &&
													moment(
														reviewLeaveDetailData.leaveEndDate
													).format("DD/MM/YYYY")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Duration</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveDuration
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Attachment</div>
											</div>
										</Col>
										<Col
											md={12}
											lg={3}
											id="attachment-align"
										>
											{attachedFileName ? (
												<p className="formValueContainer">
													<FontAwesomeIcon
														icon={faPaperclip}
														size="1x"
														color="black"
														className="formValueContainer"
													/>
													<a
														href={`${Config.server_url}/${attachedFileName}`}
														target="_blank"
														rel="noopener noreferrer"
														id="attLink"
														class="formValueContainer"
													>
														{attachedFileName &&
															attachedFileName}
													</a>
												</p>
											) : (
												<p className="formValueContainer">
													None
												</p>
											)}
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Reason</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveReason
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee's Comments</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.employeeComments
												}
											</p>
										</Col>
									</Row>
								</Col>
							</div>

							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Emergency Contact</Label>
								</div>

								<Row className="py-2 px-4">
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Person Name</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactName
											}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Phone 1</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactPhone1
											}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Phone 2</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactPhone2
											}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Address</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactAddress
											}
										</p>
									</Col>
								</Row>
							</div>
							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Application Status</Label>
								</div>
								<Row className="py-2 px-3">
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Approvers
											</div>
										</Row>
										<p className="px-2 formValueContainer">
											{
												reviewLeaveDetailData.supervisorName
											}
										</p>
										<p className="px-2 my-2 formValueContainer">
											{reviewLeaveDetailData.adminName}
										</p>
									</Col>
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Application Status
											</div>
										</Row>
										<div className="px-5 formDetailHeader">
											<p className="formValueContainer">
												{reviewLeaveDetailData.supervisorStatus
													? getImageByStatus(
															reviewLeaveDetailData.supervisorStatus
													  )
													: null}
											</p>
										</div>
										<div className="px-5 my-2 formDetailHeader">
											<p className="formValueContainer">
												{reviewLeaveDetailData.adminStatus
													? getImageByStatus(
															reviewLeaveDetailData.adminStatus
													  )
													: null}
											</p>
										</div>
									</Col>
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Comments
											</div>
										</Row>
										<div className="px-2 mr-5">
											<Input
												type="textarea"
												name="supComments"
												disabled={true}
												className="supDesciptionBox"
												value={
													reviewLeaveDetailData.supervisorComments
												}
											/>
										</div>
										<div className="px-2 mr-5">
											<Input
												type="textarea"
												disabled={true}
												name="adminMgrComments"
												className="my-2 supDesciptionBox"
												value={
													reviewLeaveDetailData.adminManagerComments
												}
											/>
										</div>
									</Col>
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Last Updated Date
											</div>
										</Row>
										<p className="px-2 formValueContainer">
											{reviewLeaveDetailData.supervisorLastUpdatedDate
												? moment(
														reviewLeaveDetailData.supervisorLastUpdatedDate
												  ).format("DD/MM/YYYY HH:mm")
												: null}
										</p>
										<p className="px-2 my-3 formValueContainer">
											{reviewLeaveDetailData.adminLastUpdatedDate
												? moment(
														reviewLeaveDetailData.adminLastUpdatedDate
												  ).format("DD/MM/YYYY HH:mm")
												: null}
										</p>
									</Col>
								</Row>
							</div>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ReviewedLeaveApplicationDetail;
